class AutoplayService {
	#started = false;
	#stopAutoplayOnFeature = false;

	get started() {
		return this.#started;
	}

	get stopAutoplayOnFeature() {
		return this.#stopAutoplayOnFeature;
	}

	start(data) {
		if (data && data.stopAutoplayOnFeature) {
			this.#stopAutoplayOnFeature = data.stopAutoplayOnFeature;
		}

		this.#started = true;
	}

	stop() {
		this.#stopAutoplayOnFeature = false;
		this.#started = false;
	}
}

export const autoplayService = new AutoplayService();
